
module.exports = function getResource(label, vars = []) {
    const resources = {
        getItShippedTitle: `Get It Shipped (${vars[0]})`
    };

    return resources[label];
};
